import React from "react";
import Icon from "assets/icons";
import classNames from "classnames";
import "react-popper-tooltip/dist/styles.css";
import { TooltipProps } from "./tooltip.type";
import useTooltipService from "./service";

function ToolTip(props: TooltipProps) {
  const service = useTooltipService(props);
  return (
    <React.Fragment>
      <span
        ref={service.setTriggerRef}
        className={classNames("tooltipIconWrapper", props.className, {
          "tooltipIconWrapper--withDefaultIcon": !props.children && !props.icon,
          "tooltipIconWrapper--withCustomIcon": props.icon
        })}>
        {props.children || (
          <span className={service.computedClassNames}>{props.icon ? props.icon : <Icon.Info />}</span>
        )}
      </span>
      {service.tooltipPortal}
    </React.Fragment>
  );
}

export default ToolTip;
